(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let observer = null;

    // The product area (photos, price, Add to cart): the wrapper of the theme's product-information
    // section. `.product-information` is the theme's own root class for that section.
    const findOverviewTarget = () => {
      const root = document.querySelector('.product-information');
      return root ? root.closest('.shopify-section') || root : null;
    };

    const scrollBehavior = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

    const goTo = (section) => {
      const details = section.querySelector('.pdp-content__details');
      if (details && !details.open) details.open = true;
      section.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      history.replaceState(null, '', `#${section.id}`);
    };

    // The product area sits right under the header and breadcrumb, so "the top of the product"
    // is the top of the page: that keeps the breadcrumb and the title in view without needing
    // a scroll offset for the header. From 990px the theme scrolls inside .page-wrapper rather
    // than the window (assets/base.css), so scroll whichever one is actually scrolling.
    const goToOverview = () => {
      const wrapper = document.querySelector('.page-wrapper');
      const scrolls = wrapper && getComputedStyle(wrapper).overflowY === 'auto';
      (scrolls ? wrapper : window).scrollTo({ top: 0, behavior: scrollBehavior() });
      history.replaceState(null, '', location.pathname + location.search);
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      if (link.hasAttribute('data-pdp-overview')) {
        event.preventDefault();
        goToOverview();
        return;
      }
      const id = link.getAttribute('href').slice(1);
      const section = id ? document.getElementById(id) : null;
      if (!section || !section.matches('[data-pdp-section]')) return;
      event.preventDefault();
      goTo(section);
    });

    // Alternating bands: every rendered content section, in page order, grey first then white.
    // This covers sections that get no nav link, and runs even when the nav stays hidden.
    // The styles live in sections/product-content.liquid and read data-pdp-band.
    const applyBands = () => {
      document.querySelectorAll('[data-pdp-section]').forEach((section, index) => {
        section.dataset.pdpBand = index % 2 === 0 ? 'grey' : 'white';
      });
    };

    // Price and Add to cart at the right-hand end of the bar. Shown only while the main Add to cart
    // button is scrolled out of view above the screen. They mirror the main product form.
    let teardownBuy = null;
    const MAIN_BUTTON = '.product-information product-form-component [ref="addToCartButton"]';

    const setupBuy = (nav) => {
      if (teardownBuy) teardownBuy();
      teardownBuy = null;
      const group = nav.querySelector('[data-pdp="nav-buy"]');
      if (!group) return;
      const priceEl = group.querySelector('[data-pdp-nav-price]');
      const button = group.querySelector('[data-pdp-nav-button]');
      const title = button.dataset.title || '';
      const controller = new AbortController();
      const { signal } = controller;
      let watched = null;
      let scrolledPast = false;
      let pending = false;

      const labelOf = (main) => {
        const copy = main.cloneNode(true);
        copy.querySelectorAll('.add-to-cart__added, .svg-wrapper, .visually-hidden').forEach((node) => node.remove());
        return copy.textContent.replace(/\s+/g, ' ').trim();
      };

      const priceOf = () => {
        const price = document.querySelector('.product-information product-price .price:not(.compare-at-price)');
        if (!price) return '';
        const copy = price.cloneNode(true);
        copy.querySelectorAll('.visually-hidden').forEach((node) => node.remove());
        return copy.textContent.replace(/\s+/g, ' ').trim();
      };

      const show = () => {
        group.hidden = !(scrolledPast && watched);
      };

      const intersection = new IntersectionObserver(
        (changes) => {
          const change = changes[changes.length - 1];
          scrolledPast = !change.isIntersecting && change.boundingClientRect.top < 0;
          show();
        },
        { threshold: 0 }
      );

      const sync = () => {
        pending = false;
        const main = document.querySelector(MAIN_BUTTON);
        if (main !== watched) {
          if (watched) intersection.unobserve(watched);
          watched = main;
          scrolledPast = false;
          if (main) intersection.observe(main);
        }
        if (main) {
          const label = labelOf(main);
          if (label) {
            button.textContent = label;
            button.setAttribute('aria-label', `${label}: ${title}`);
          }
          button.disabled = main.disabled;
          button.classList.toggle('pdp-nav__button--preorder', Boolean(main.querySelector('.add-to-cart-preorder-flag')));
          const price = priceOf();
          if (price) priceEl.textContent = price;
        }
        show();
      };
      const queueSync = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(sync);
      };

      // Click the main button the way Horizon's own sticky bar does: flag it so the main button
      // skips its fly-to-cart animation (its photo may be off screen), then reset the flag when the
      // cart request settles. The main form adds the selected variant with its quantity, and the
      // theme shows its usual cart feedback.
      button.addEventListener(
        'click',
        () => {
          const main = document.querySelector(MAIN_BUTTON);
          if (!main || main.disabled) return;
          main.dataset.puppet = 'true';
          main.click();
          const done = () => {
            main.dataset.puppet = 'false';
          };
          const settle = (event) => {
            document.removeEventListener('shopify:cart:lines-update', settle);
            document.removeEventListener('shopify:cart:error', settle);
            if (event.promise && typeof event.promise.finally === 'function') event.promise.finally(done);
            else done();
          };
          document.addEventListener('shopify:cart:lines-update', settle);
          document.addEventListener('shopify:cart:error', settle);
          setTimeout(() => {
            document.removeEventListener('shopify:cart:lines-update', settle);
            document.removeEventListener('shopify:cart:error', settle);
            done();
          }, 10000);
        },
        { signal }
      );

      const mirror = new MutationObserver(queueSync);
      const root = findOverviewTarget();
      if (root) {
        mirror.observe(root, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });
      }

      sync();
      teardownBuy = () => {
        controller.abort();
        intersection.disconnect();
        mirror.disconnect();
        group.hidden = true;
      };
    };

    const build = () => {
      applyBands();
      if (observer) observer.disconnect();
      observer = null;

      const nav = document.querySelector('[data-pdp="section-nav"]');
      if (!nav) return;
      const inner = nav.querySelector('.pdp-nav__links');
      inner.replaceChildren();

      const sections = [...document.querySelectorAll('[data-pdp-section]')].filter(
        (section) => section.id && section.dataset.pdpLabel
      );
      if (sections.length < 2) {
        nav.hidden = true;
        if (teardownBuy) teardownBuy();
        teardownBuy = null;
        return;
      }

      // Entries in page order: the Overview first (when it has a label and a target), then each section.
      const overviewLabel = (nav.dataset.overviewLabel || '').trim();
      const overviewTarget = overviewLabel ? findOverviewTarget() : null;
      const entries = [];
      if (overviewTarget) {
        const link = document.createElement('a');
        link.className = 'pdp-nav__link';
        link.setAttribute('data-pdp-overview', '');
        link.href = overviewTarget.id ? `#${overviewTarget.id}` : '#';
        link.textContent = overviewLabel;
        inner.append(link);
        entries.push({ element: overviewTarget, link });
      }
      sections.forEach((section) => {
        const link = document.createElement('a');
        link.className = 'pdp-nav__link';
        link.href = `#${section.id}`;
        link.textContent = section.dataset.pdpLabel;
        inner.append(link);
        entries.push({ element: section, link });
      });
      nav.hidden = false;
      setupBuy(nav);

      // Exactly one link is current. The Overview starts as current (top of the page on load);
      // the observer then moves it to the last entry that is inside the band under the header.
      const setCurrent = (current) => {
        entries.forEach((entry) => {
          if (entry === current) entry.link.setAttribute('aria-current', 'true');
          else entry.link.removeAttribute('aria-current');
        });
      };
      setCurrent(entries[0]);

      const inView = new Set();
      observer = new IntersectionObserver(
        (changes) => {
          for (const change of changes) {
            if (change.isIntersecting) inView.add(change.target);
            else inView.delete(change.target);
          }
          const current = entries.filter((entry) => inView.has(entry.element)).pop();
          if (current) setCurrent(current);
        },
        { rootMargin: '-80px 0px -60% 0px' }
      );
      entries.forEach((entry) => observer.observe(entry.element));
    };

    build();
    // Deferred so that on unload the removed section is already out of the page when we count.
    const rebuild = () => setTimeout(build, 0);
    document.addEventListener('shopify:section:load', rebuild);
    document.addEventListener('shopify:section:unload', rebuild);
    document.addEventListener('shopify:section:reorder', rebuild);
  })();

  } catch(e) { console.error(e); }
})();
})();
